export const PUBLIC_LIGHT_ROUTES = ['/', '/privacypolicy', '/termsandconditions'];

export const isPublicLightRoute = (pathname) => PUBLIC_LIGHT_ROUTES.includes(pathname);
